document.addEventListener("DOMContentLoaded", initAppointmentScheduler);

function initAppointmentScheduler() {
    setupAppointmentWidget();
    setupAppointmentButtonState();
    setupModalCloseHandlers();
}

function setupAppointmentWidget() {
    const branchWrapper = document.querySelector('.boa-sticky-branch-container');
    const appointmentModal = document.getElementById("appointmentModal");

    if (!branchWrapper || !appointmentModal) {
        return;
    }
    const scheduleButton = branchWrapper.querySelector("#appointmentGoBtn");
    const branchSelector = branchWrapper.querySelector("#appointmentSelector");
    const modalCloseBtn = appointmentModal.querySelector(".modal-btn-close");
    const appointmentIframe = appointmentModal.querySelector("#inlineFrameAppointment");

    // Initial button state
    scheduleButton.disabled = !branchSelector.value;

    scheduleButton?.addEventListener("click", () => {
        handleAppointmentSchedule(branchSelector, appointmentModal, appointmentIframe);
    });

    modalCloseBtn?.addEventListener("click", () => {
        closeAppointmentModal(appointmentModal, appointmentIframe);
    });
}

function setupAppointmentButtonState() {
    const branchSelector = document.getElementById("appointmentSelector");
    const scheduleButton = document.getElementById("appointmentGoBtn");

    branchSelector.addEventListener("change", () => {
        scheduleButton.disabled = !branchSelector.value;
    });
}

function setupModalCloseHandlers() {
    const appointmentModal = document.getElementById("appointmentModal");
  
    appointmentModal.addEventListener("click", (e) => {
        if (e.target === appointmentModal) {
            appointmentModal.classList.add('modal-static');
            setTimeout(() => {
                appointmentModal.classList.remove('modal-static');
            }, 100)
        }
    });
}

function handleAppointmentSchedule(selector, modal, iframe) {
    const selectedUrl = selector.value;
    if (selectedUrl) {
        iframe.src = selectedUrl;
        modal.classList.add("show");
    }
}

function closeAppointmentModal(modal, iframe) {
    modal.classList.remove("show");
    iframe.src = "";
}